import React, { FC, ReactNode } from 'react';

import { Box, BoxProps } from '@/components/lib/components/Box';
import { ds } from '@/components/lib/design.system';

export interface AccountLinkProps extends BoxProps {
    children: ReactNode;
}

export const AccountLink: FC<AccountLinkProps> = ({ children, ...props }) => {
    return (
        <Box
            backgroundColor={ds.colorToken.background.neutral.subtler}
            borderRadius={'r16'}
            paddingHorizontal={'s16'}
            borderWidth={1}
            borderColor={ds.colorToken.border.subtle}
            {...props}
        >
            {children}
        </Box>
    );
};
